<template>
  <div>
    <popup
      :fullscreen="false"
      :width="width"
      @updateClosePopup="onPreview(null)"
      height-head="40px"
      title="Preview document"
      transition="scale-transition"
      is-hide-bottom
    >
	    <embed :src="previewLink" :width="embedWidth" :height="embedHeight" />
    </popup>
  </div>
</template>
<script>
// services
import { mapActions, mapGetters } from "vuex";
import Popup from "@/shared/Popup/Popup";

export default {
	name: "PreviewDocument",
	components: { Popup },
	props: {
		width: [ Number, String ]
	},
	computed: {
		...mapGetters([ 'previewLink' ]),
		embedHeight() {
			return self.innerHeight - 200;
		},
		embedWidth() {
			return self.innerWidth - 100;
		},
	},
	methods: mapActions([ "onPreview" ]),
};
</script>
